module.exports = __webpack_public_path__ + "static/media/ui-virtual-event-apps.1a2aebc0.png";